<template>
  <el-dialog title="批注预览" :visible.sync="dialogVisible" width="75%" top="10px">
        <img class="page-img" :src="imgs" alt="">
  </el-dialog>
</template>

<script>
export default {
    props:['boardId'],
  data() {
    return {
      dialogVisible: false,
      pages:[],
      imgs:'',
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async writingDetail(){
        const res = await this.$axios.post("/base/board/detail",{
            board_id:this.boardId,
        });
      if (res.status == 200 && res.data.errCode == 0) {
          this.pages = res.data.data.pages
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
  watch: {
    boardId (newName, oldName) {
        this.boardId = newName
    }
}
};
</script>

<style lang="scss" scoped>
.page-img{
    width: 100%;
    height: 770px;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/pizhu/detail.vue